module.exports = __webpack_public_path__ + "static/media/car-alt.1099afbc.svg";